import React from 'react';

const PlayStore = () => {
  return (
    <svg
      width='206'
      height='60'
      viewBox='0 0 206 60'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M198.368 60H7.63244C3.42588 60 0 56.6185 0 52.5V7.5C0 3.36658 3.42588 0 7.63244 0H198.368C202.57 0 206 3.36658 206 7.5V52.5C206 56.6185 202.57 60 198.368 60Z'
        fill='black'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M198.368 1.20075C201.896 1.20075 204.784 4.03242 204.784 7.5V52.5C204.784 55.9676 201.915 58.7993 198.368 58.7993H7.63244C4.10424 58.7993 1.21649 55.9676 1.21649 52.5V7.5C1.21649 4.03242 4.08529 1.20075 7.63244 1.20075H198.368ZM198.368 0H7.63244C3.42588 0 0 3.38155 0 7.5V52.5C0 56.6334 3.42588 60 7.63244 60H198.368C202.57 60 206 56.6334 206 52.5V7.5C206 3.38155 202.57 0 198.368 0Z'
        fill='#A6A6A6'
      />
      <path
        d='M108.522 19.8479C107.146 19.8479 105.986 19.3728 105.069 18.4377C104.16 17.5287 103.652 16.2756 103.675 14.9963C103.675 13.6309 104.145 12.4751 105.069 11.5586C105.983 10.6234 107.142 10.1484 108.518 10.1484C109.878 10.1484 111.038 10.6234 111.97 11.5586C112.895 12.505 113.365 13.6608 113.365 14.9963C113.35 16.3653 112.88 17.5212 111.97 18.4339C111.057 19.3766 109.897 19.8479 108.522 19.8479ZM67.5892 19.8479C66.2438 19.8479 65.0766 19.3803 64.1216 18.4564C63.1742 17.5362 62.6929 16.3728 62.6929 15C62.6929 13.6272 63.1742 12.4638 64.1216 11.5436C65.0576 10.6197 66.2249 10.1521 67.5892 10.1521C68.2561 10.1521 68.9042 10.283 69.5257 10.5486C70.1358 10.8067 70.6323 11.1584 70.9999 11.5885L71.0908 11.697L70.0638 12.692L69.9577 12.5686C69.3779 11.8878 68.601 11.5549 67.574 11.5549C66.6569 11.5549 65.8573 11.8766 65.1979 12.5125C64.5347 13.1521 64.1974 13.99 64.1974 15.0037C64.1974 16.0175 64.5347 16.8554 65.1979 17.495C65.8573 18.1309 66.6569 18.4526 67.574 18.4526C68.5517 18.4526 69.3741 18.1309 70.0146 17.495C70.3935 17.1209 70.6285 16.5973 70.7119 15.9352H67.4186V14.5362H72.1254L72.1444 14.6633C72.1785 14.899 72.2126 15.1421 72.2126 15.3666C72.2126 16.6571 71.8184 17.7007 71.0378 18.4713C70.151 19.384 68.9913 19.8479 67.5892 19.8479ZM122.013 19.6496H120.561L116.116 12.6284L116.154 13.8928V19.6459H114.703V10.3504H116.359L116.404 10.4214L120.584 17.0349L120.546 15.7743V10.3504H122.013V19.6496ZM97.6149 19.6496H96.1445V11.7494H93.594V10.3504H100.162V11.7494H97.6111V19.6496H97.6149ZM92.3965 19.6496H90.9299V10.3504H92.3965V19.6496ZM84.1539 19.6496H82.6873V11.7494H80.1368V10.3504H86.7043V11.7494H84.1539V19.6496ZM79.2083 19.6347H73.5844V10.3504H79.2083V11.7494H75.0548V14.3005H78.8028V15.6845H75.0548V18.2357H79.2083V19.6347ZM106.145 17.4763C106.801 18.1234 107.597 18.4489 108.522 18.4489C109.473 18.4489 110.25 18.1309 110.898 17.4763C111.542 16.8404 111.868 16.0062 111.868 15C111.868 13.9938 111.542 13.1559 110.902 12.5237C110.246 11.8766 109.446 11.5511 108.525 11.5511C107.574 11.5511 106.797 11.8691 106.153 12.5237C105.509 13.1596 105.183 13.9938 105.183 15C105.183 16.0062 105.505 16.8441 106.145 17.4763Z'
        fill='white'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M103.538 32.6334C99.9569 32.6334 97.054 35.3155 97.054 39.015C97.054 42.6808 99.9759 45.3965 103.538 45.3965C107.119 45.3965 110.022 42.6958 110.022 39.015C110.022 35.3155 107.119 32.6334 103.538 32.6334ZM103.538 42.8678C101.579 42.8678 99.8925 41.2668 99.8925 39C99.8925 36.6995 101.583 35.1322 103.538 35.1322C105.497 35.1322 107.184 36.6995 107.184 39C107.188 41.2818 105.497 42.8678 103.538 42.8678ZM89.3912 32.6334C85.81 32.6334 82.9071 35.3155 82.9071 39.015C82.9071 42.6808 85.8289 45.3965 89.3912 45.3965C92.9725 45.3965 95.8754 42.6958 95.8754 39.015C95.8754 35.3155 92.9687 32.6334 89.3912 32.6334ZM89.3912 42.8678C87.432 42.8678 85.7456 41.2668 85.7456 39C85.7456 36.6995 87.4358 35.1322 89.3912 35.1322C91.3505 35.1322 93.0369 36.6995 93.0369 39C93.0369 41.2818 91.3505 42.8678 89.3912 42.8678ZM72.5574 34.5823V37.283H79.125C78.9241 38.798 78.4163 39.9165 77.6394 40.6833C76.6768 41.6334 75.1913 42.6658 72.5726 42.6658C68.5366 42.6658 65.3798 39.4489 65.3798 35.4651C65.3798 31.4813 68.5366 28.2643 72.5726 28.2643C74.7517 28.2643 76.3395 29.1135 77.5181 30.1983L79.4585 28.283C77.8213 26.7344 75.6422 25.5486 72.5878 25.5486C67.051 25.5486 62.4048 30 62.4048 35.4501C62.4048 40.9152 67.0472 45.3516 72.5878 45.3516C75.5778 45.3516 77.8213 44.3865 79.5949 42.5686C81.4026 40.7843 81.9748 38.2668 81.9748 36.2357C81.9748 35.6035 81.9256 35.0349 81.8232 34.5524H72.5536C72.5574 34.5486 72.5574 34.5823 72.5574 34.5823ZM141.412 36.6845C140.87 35.2519 139.233 32.6185 135.876 32.6185C132.548 32.6185 129.782 35.2032 129.782 39C129.782 42.5835 132.518 45.3815 136.198 45.3815C139.154 45.3815 140.874 43.5973 141.583 42.5499L139.389 41.0985C138.661 42.1646 137.649 42.8641 136.213 42.8641C134.761 42.8641 133.746 42.2132 133.071 40.9302L141.716 37.3953C141.716 37.399 141.412 36.6845 141.412 36.6845ZM132.598 38.8167C132.529 36.3516 134.538 35.0985 135.974 35.0985C137.107 35.0985 138.051 35.6484 138.373 36.4489L132.598 38.8167ZM125.575 45H128.414V26.2519H125.575V45ZM120.914 34.0511H120.812C120.171 33.2993 118.955 32.6185 117.401 32.6185C114.176 32.6185 111.205 35.4202 111.205 39.0187C111.205 42.6022 114.161 45.3703 117.401 45.3703C118.936 45.3703 120.171 44.6858 120.812 43.919H120.914V44.8354C120.914 47.2706 119.595 48.5835 117.469 48.5835C115.73 48.5835 114.65 47.3491 114.21 46.3167L111.743 47.3342C112.452 49.0175 114.343 51.101 117.465 51.101C120.793 51.101 123.612 49.1671 123.612 44.4501V33H120.929V34.0511C120.933 34.0511 120.914 34.0511 120.914 34.0511ZM117.655 42.8678C115.695 42.8678 114.058 41.2519 114.058 39.0187C114.058 36.7668 115.695 35.1359 117.655 35.1359C119.595 35.1359 121.1 36.7855 121.1 39.0187C121.119 41.2519 119.599 42.8678 117.655 42.8678ZM154.703 26.2519H147.915V45H150.754V37.9003H154.707C157.848 37.9003 160.937 35.6521 160.937 32.0835C160.937 28.515 157.86 26.2519 154.703 26.2519ZM154.786 35.2818H150.75V28.8479H154.786C156.912 28.8479 158.114 30.5798 158.114 32.0648C158.114 33.5349 156.897 35.2818 154.786 35.2818ZM172.313 32.5998C170.252 32.5998 168.126 33.5012 167.247 35.4651L169.763 36.4975C170.305 35.4651 171.298 35.1135 172.348 35.1135C173.818 35.1135 175.304 35.9813 175.338 37.5299V37.7282C174.83 37.4439 173.716 37.01 172.382 37.01C169.665 37.01 166.909 38.4763 166.909 41.2257C166.909 43.7431 169.138 45.3591 171.62 45.3591C173.526 45.3591 174.576 44.51 175.232 43.5262H175.334V44.9776H178.07V37.7955C178.07 34.4514 175.554 32.5998 172.313 32.5998ZM171.957 42.8678C171.029 42.8678 169.729 42.419 169.729 41.2668C169.729 39.8155 171.351 39.2656 172.734 39.2656C173.985 39.2656 174.576 39.5312 175.319 39.8978C175.114 41.581 173.674 42.8529 171.957 42.8678ZM188.052 33L184.793 41.1322H184.691L181.314 33H178.26L183.326 44.3678L180.439 50.6858H183.395L191.19 33H188.052ZM162.502 45H165.34V26.2519H162.502V45Z'
        fill='white'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15.856 11.3005C15.4164 11.7681 15.1625 12.4825 15.1625 13.4177V46.586C15.1625 47.5212 15.4164 48.2357 15.8712 48.6845L15.9887 48.7855L34.8159 30.202V29.7868L15.9735 11.1995L15.856 11.3005Z'
        fill='url(#paint0_linear_12_141)'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M41.0802 36.4152L34.8007 30.217V29.783L41.0802 23.5848L41.2167 23.6671L48.6445 27.8342C50.7705 29.0162 50.7705 30.9688 48.6445 32.1658L41.2167 36.3329L41.0802 36.4152Z'
        fill='url(#paint1_linear_12_141)'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M41.2167 36.3329L34.8007 30L15.8561 48.6995C16.5496 49.4327 17.713 49.515 19.0129 48.8005L41.2167 36.3329Z'
        fill='url(#paint2_linear_12_141)'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M41.2167 23.6671L19.0129 11.2182C17.713 10.485 16.5458 10.586 15.8561 11.3192L34.8007 30L41.2167 23.6671Z'
        fill='url(#paint3_linear_12_141)'
      />
      <path
        opacity='0.2'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M41.0802 36.1983L19.028 48.5648C17.7964 49.2644 16.6974 49.2157 15.9887 48.5798L15.8712 48.6958L15.9887 48.7968C16.6974 49.4289 17.7964 49.4813 19.028 48.7818L41.2318 36.3329L41.0802 36.1983Z'
        fill='black'
      />
      <path
        opacity='0.12'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M48.6444 31.9489L41.0613 36.1983L41.1977 36.3329L48.6255 32.1658C49.6904 31.5673 50.2134 30.7818 50.2134 30C50.149 30.7182 49.607 31.399 48.6444 31.9489Z'
        fill='black'
      />
      <path
        opacity='0.25'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M19.0129 11.4352L48.6445 28.0511C49.607 28.586 50.149 29.2855 50.2323 30C50.2323 29.2182 49.7094 28.4327 48.6445 27.8342L19.0129 11.2182C16.8868 10.0174 15.1625 11.0199 15.1625 13.4177V13.6347C15.1625 11.2332 16.8868 10.2494 19.0129 11.4352Z'
        fill='white'
      />
      <defs>
        <linearGradient
          id='paint0_linear_12_141'
          x1='33.1271'
          y1='13.0598'
          x2='3.02188'
          y2='21.1866'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#00A0FF' />
          <stop offset='0.00657' stopColor='#00A1FF' />
          <stop offset='0.2601' stopColor='#00BEFF' />
          <stop offset='0.5122' stopColor='#00D2FF' />
          <stop offset='0.7604' stopColor='#00DFFF' />
          <stop offset='1' stopColor='#00E3FF' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_12_141'
          x1='51.417'
          y1='30.0001'
          x2='14.6458'
          y2='30.0001'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FFE000' />
          <stop offset='0.4087' stopColor='#FFBD00' />
          <stop offset='0.7754' stopColor='#FFA500' />
          <stop offset='1' stopColor='#FF9C00' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_12_141'
          x1='37.7279'
          y1='33.446'
          x2='13.9806'
          y2='73.9388'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF3A44' />
          <stop offset='1' stopColor='#C31162' />
        </linearGradient>
        <linearGradient
          id='paint3_linear_12_141'
          x1='11.0856'
          y1='0.268192'
          x2='21.6801'
          y2='18.3527'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#32A071' />
          <stop offset='0.0685' stopColor='#2DA771' />
          <stop offset='0.4762' stopColor='#15CF74' />
          <stop offset='0.8009' stopColor='#06E775' />
          <stop offset='1' stopColor='#00F076' />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default PlayStore;
